export default class Resource {
    constructor(
        public id:          number,
        public name:        string,
        public description: string,
        public url:         string
    ) { }
}
